import Matrix from 'ml-matrix';
import simpleClustering from 'ml-simple-clustering';
export function ensureSpinSystemProps(spinSystem) {
    const { couplingConstants, connectivity } = spinSystem;
    const nCouplingConstants = Matrix.checkMatrix(couplingConstants);
    const nConnectivity = connectivity
        ? Matrix.checkMatrix(connectivity)
        : connectivityMatrixFromCouplingMatrix(nCouplingConstants);
    const { levels = new Array(nConnectivity.rows).fill(2), clusters = simpleClustering(nConnectivity.to2DArray(), {
        out: 'indexes',
    }), } = spinSystem;
    return {
        ...spinSystem,
        levels,
        clusters,
        connectivity: nConnectivity,
        couplingConstants: nCouplingConstants,
    };
}
function connectivityMatrixFromCouplingMatrix(couplingConstants) {
    const connectivity = Matrix.ones(couplingConstants.rows, couplingConstants.rows);
    for (let i = 0; i < couplingConstants.rows; i++) {
        for (let j = i; j < couplingConstants.columns; j++) {
            if (couplingConstants.get(i, j) === 0) {
                connectivity.set(i, j, 0);
                connectivity.set(j, i, 0);
            }
        }
    }
    return connectivity;
}
//# sourceMappingURL=ensureSpinSystemProps.js.map